export interface TransportationFilters {
    dateOfRegistrationFrom: string;
    dateOfRegistrationTo: string;
    arrivalDepartureTime: string;
    ferryEntityId: string;
    relationType: string;
    status: string;
}

export enum TransportType {
    WAGON = "WAGON",
    TRAILER = "TRAILER",
    LORRY = "LORRY",
    OWN = "OWN",
    LORRY_TRAILER = "LORRY_TRAILER"
}

export enum Direction {
    IN = "IN",
    OUT = "OUT"
}

export enum SideType {
    LEFT = "LEFT",
    RIGHT = "RIGHT",
    FRONT = "FRONT",
    REAR = "REAR",
    TOP = "TOP"
}

export enum PaymentMethod {
    CASH = "CASH",
    BANK_TRANSFER = "BANK_TRANSFER"
}